export const videoHotlineCatgoryConstants = {
	VideoHotlineCategoryGetByfilterRequest: "VIDEOHOTLINE_CATEGORY_GET_BY_FILTER_STARTED",
	VideoHotlineCategoryGetByfilterSuccess: "VIDEOHOTLINE_CATEGORY_GET_BY_FILTER_COMPLETED",
	VideoHotlineCategoryGetByfilterFailure: "VIDEOHOTLINE_CATEGORY_GET_BY_FILTER_FAILED",

    VideoHotlineCategoryUpdateStatusRequest: "VIDEOHOTLINE_CATEGORY_UPDATE_STATUS_STARTED",
	VideoHotlineCategoryUpdateStatusSuccess: "VIDEOHOTLINE_CATEGORY_UPDATE_STATUS_COMPLETED",
	VideoHotlineCategoryUpdateStatusFailure: "VIDEOHOTLINE_CATEGORY_UPDATE_STATUS_FAILED",

    VideoHotlineCategoryCreateRequest: "VIDEOHOTLINE_CATEGORY_CREATE_STARTED",
	VideoHotlineCategoryCreateSuccess: "VIDEOHOTLINE_CATEGORY_CREATE_COMPLETED",
	VideoHotlineCategoryCreateFailure: "VIDEOHOTLINE_CATEGORY_CREATE_FAILED",

	VideoHotlineCategoryUpdateRequest: "VIDEOHOTLINE_CATEGORY_UPDATE_STARTED",
	VideoHotlineCategoryUpdateSuccess: "VIDEOHOTLINE_CATEGORY_UPDATE_COMPLETED",
	VideoHotlineCategoryUpdateFailure: "VIDEOHOTLINE_CATEGORY_UPDATE_FAILED",

	VideoHotlineCategoryDeleteRequest: "VIDEOHOTLINE_CATEGORY_DELETE_STARTED",
	VideoHotlineCategoryDeleteSuccess: "VIDEOHOTLINE_CATEGORY_DELETE_COMPLETED",
	VideoHotlineCategoryDeleteFailure: "VIDEOHOTLINE_CATEGORY_DELETE_FAILED",
};
